import { render, staticRenderFns } from "./exhibition-activity.vue?vue&type=template&id=21382d2f&scoped=true&"
import script from "./exhibition-activity.vue?vue&type=script&lang=js&"
export * from "./exhibition-activity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21382d2f",
  null
  
)

export default component.exports